import React from "react";

type Props = {
  className?: string;
};

export default function Skeleton({ className = "" }: Props): React.ReactElement {
  return (
    <div
      className={`animate-pulse rounded bg-gradient-to-r from-bg-raised via-bg-hover to-bg-raised bg-[length:200%_100%] ${className}`}
      aria-hidden="true"
    />
  );
}
